import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Testimonials from "./pages/Testimonials";
import Payment from "./pages/Payment";
import PaymentSuccess from "./pages/PaymentSuccess";
import Enquiry from "./pages/Enquiry";
import JobSeekers from "./pages/JobSeekers";
import Enterprise from "./pages/Enterprise";
import ProfileBuilding from "./pages/ProfileBuilding";
import Admin from "./pages/Admin";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<><Navigation /><Home /><Footer /></>} />
          <Route path="/services" element={<><Navigation /><Services /><Footer /></>} />
          <Route path="/testimonials" element={<><Navigation /><Testimonials /><Footer /></>} />
          <Route path="/payment" element={<><Navigation /><Payment /><Footer /></>} />
          <Route path="/payment/success" element={<><Navigation /><PaymentSuccess /></>} />
          <Route path="/enquiry" element={<><Navigation /><Enquiry /><Footer /></>} />
          <Route path="/job-seekers" element={<><Navigation /><JobSeekers /><Footer /></>} />
          <Route path="/enterprise" element={<><Navigation /><Enterprise /><Footer /></>} />
          <Route path="/profile-building" element={<><Navigation /><ProfileBuilding /><Footer /></>} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;